<template>
  <div class="usdt-page">
    <div v-if="loading" class="state-wrap">
      <div class="loader"></div>
      <p>正在加载支付信息...</p>
    </div>

    <div v-else-if="error" class="state-wrap card">
      <p class="error-text">{{ error }}</p>
    </div>

    <div v-else-if="paid" class="state-wrap card">
      <div class="result-icon ok">✓</div>
      <h3>支付成功</h3>
      <p>预计到账时间为 1–3 分钟</p>
    </div>

    <div v-else-if="expired" class="state-wrap card">
      <div class="result-icon timeout">!</div>
      <h3>订单已超时</h3>
      <p>请返回并重新发起支付</p>
    </div>

    <div v-else class="box">
      <p class="box-top">
        <img class="usdt-logo" src="/imgs/usdt.png" :alt="currencyCode" />
        <span class="total-amount">{{ displayAmount }}&nbsp;{{ currencyCode }}</span>
      </p>
      <p class="dzje">请使用 {{ currencyCode }}（{{ chainCode }}）完成支付</p>

      <div class="box-main">
        <p class="czje">
          <span>货币：</span>
          <span class="price">{{ currencyCode }}</span>
        </p>
        <p class="czje">
          <span>订单金额：</span>
          <span class="price">{{ displayAmount }} {{ currencyCode }}</span>
        </p>
        <p class="czje">
          <span>支付金额：</span>
          <span class="price accent">{{ displayAmount }} {{ currencyCode }}</span>
        </p>
        <p class="czje">
          <span>网络：</span>
          <span class="price network">
            <img src="/imgs/trc20.png" :alt="chainCode" />
            {{ chainCode }}
          </span>
        </p>
        <p class="czje">
          <span>订单号：</span>
          <span class="price mono-sm">
            {{ data.merchantOrderNo }}
            <button type="button" class="mini-copy" @click="copyText(data.merchantOrderNo)">复制</button>
          </span>
        </p>

        <p class="sxf">请仅向 {{ networkName }} 网络发送 {{ currencyCode }}，使用其他网络将导致资金丢失</p>

        <div v-if="!showQr" class="form-box">
          <button type="button" class="paysubmit" @click="openPayPanel">确认支付</button>
        </div>
        <p v-if="!showQr" class="dzsj">预计到账时间为 1–3 分钟</p>

        <div v-else class="qrcode_usdt">
          <p class="qrcode_title">{{ currencyCode }} 充值</p>
          <div class="qrcode_form">
            <div class="form_list">
              <span class="qrcode_label">需支付总额</span>
              <div class="qrcode_right">
                <span class="qrcode_price">
                  <span class="fwb">{{ displayAmount }}</span>
                  <span>{{ currencyCode }}</span>
                </span>
                <button type="button" class="qrcode_copy" @click="copyText(displayAmount)">复制</button>
              </div>
            </div>
            <div class="form_list form_tips">请支付确切的货币金额</div>

            <div class="form_list">
              <span class="qrcode_label">请将下列地址（{{ networkName }} network only）</span>
              <div class="qrcode_right">
                <p class="qrcode_price qrcode_price1" :title="walletAddress">{{ walletAddress }}</p>
                <button type="button" class="qrcode_copy" @click="copyText(walletAddress)">复制</button>
              </div>
            </div>
            <div class="form_list form_tips">请核对复制后的地址是否一致，支付地址错误将无法给您到账</div>
            <div class="form_list form_tips warn">请仅在 {{ networkName }} 网络上发送 {{ currencyCode }}，使用其他网络将导致资金丢失</div>

            <div class="form_list qrcode_center">
              <div class="qrcode_code">
                <div ref="qrcode" class="qrcode-el"></div>
              </div>
            </div>

            <div class="qrcode_djs">
              <span>剩余 {{ countdownLabel }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import QRCode from 'qrcodejs2'
import apiConfig from '@/config/api'

export default {
  name: 'UsdtTransfer',
  data() {
    return {
      data: {},
      loading: true,
      error: null,
      countdownSeconds: 0,
      countdownTimerId: null,
      expired: false,
      paid: false,
      showQr: false,
      qrcodeInstance: null,
      walletAddress: ''
    }
  },
  computed: {
    displayAmount() {
      const n = this.data.paymentAmount
      if (n === undefined || n === null || n === '') return ''
      return String(n)
    },
    currencyCode() {
      return String(this.data.currency || '').trim().toUpperCase() || 'USDT'
    },
    chainCode() {
      return String(this.data.chain || '').trim().toUpperCase() || 'TRC20'
    },
    networkName() {
      const name = String(this.data.networkName || '').trim()
      if (name) return name
      const map = {
        TRC20: 'TRON',
        ERC20: 'Ethereum',
        BEP20: 'BSC',
        POLYGON: 'Polygon',
        SOL: 'Solana'
      }
      return map[this.chainCode] || this.chainCode
    },
    countdownLabel() {
      const mins = Math.floor(this.countdownSeconds / 60)
      const secs = this.countdownSeconds % 60
      return `${mins} 分 ${String(secs).padStart(2, '0')} 秒`
    }
  },
  created() {
    this.loadOrder()
  },
  beforeDestroy() {
    this.clearCountdown()
    this.clearQr()
  },
  methods: {
    toast(msg) {
      if (window.layui && window.layui.layer) {
        window.layui.layer.msg(msg, { icon: 1, time: 1500 })
      } else {
        alert(msg)
      }
    },
    copyText(text) {
      if (!text) return
      const textarea = document.createElement('textarea')
      textarea.value = String(text)
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.toast('已复制到剪贴板')
    },
    decodeAddress(payCode, payerAccount) {
      if (payerAccount) return String(payerAccount).trim()
      if (!payCode) return ''
      try {
        return atob(String(payCode)).trim()
      } catch (e) {
        return String(payCode).trim()
      }
    },
    clearCountdown() {
      if (this.countdownTimerId) {
        clearInterval(this.countdownTimerId)
        this.countdownTimerId = null
      }
    },
    startCountdown(totalSeconds) {
      this.clearCountdown()
      this.countdownSeconds = totalSeconds
      this.countdownTimerId = setInterval(() => {
        if (this.countdownSeconds > 0) {
          this.countdownSeconds--
          if (this.countdownSeconds === 0) {
            this.clearCountdown()
            this.expired = true
          }
        }
      }, 1000)
    },
    clearQr() {
      if (this.$refs.qrcode) {
        this.$refs.qrcode.innerHTML = ''
      }
      this.qrcodeInstance = null
    },
    renderQr(text) {
      if (!text) return
      this.$nextTick(() => {
        if (!this.$refs.qrcode) return
        this.clearQr()
        this.qrcodeInstance = new QRCode(this.$refs.qrcode, {
          text,
          width: 200,
          height: 200,
          colorDark: '#111111',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    openPayPanel() {
      if (!this.walletAddress) {
        this.toast('暂无收款地址')
        return
      }
      this.showQr = true
      this.renderQr(this.walletAddress)
    },
    loadOrder() {
      const merchantOrderNo = this.$route.params.merchantOrderNo
      axios
        .get(apiConfig.getCommonInterfaceUrl(), { params: { merchantOrderNo } })
        .then((res) => {
          if (res.data.code !== 200) {
            this.error = res.data.msg || '订单获取失败'
            return
          }
          this.data = res.data.data || {}
          if (Number(this.data.order_status) === 1) {
            this.paid = true
            return
          }
          if (Number(this.data.order_status) === -1) {
            this.expired = true
            return
          }
          this.walletAddress = this.decodeAddress(this.data.payCode, this.data.payerAccount)
          const expireTime = new Date(this.data.expire_time).getTime()
          const diffSeconds = Math.floor((expireTime - Date.now()) / 1000)
          if (diffSeconds > 0) {
            this.startCountdown(diffSeconds)
          } else {
            this.expired = true
          }
        })
        .catch(() => {
          this.error = '请求失败，无法获取订单信息'
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.usdt-page {
  min-height: 100vh;
  background: #3464ff;
  box-sizing: border-box;
  padding: 24px 12px 48px;
  font-family: PingFangSC-Regular, 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.box {
  width: min(560px, 92%);
  margin: 16px auto 0;
}

.box-top {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 34px;
  font-weight: 500;
  line-height: 1.2;
  margin: 0;
}

.usdt-logo {
  width: 72px;
  height: 72px;
  margin-right: 12px;
  object-fit: contain;
}

.total-amount {
  letter-spacing: 0.5px;
}

.dzje {
  margin: 16px 0 28px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  text-align: center;
}

.box-main {
  padding: 8px 28px 36px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 1px 6px rgba(117, 117, 117, 0.25);
}

.czje {
  color: #333;
  font-size: 16px;
  line-height: 54px;
  min-height: 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e8ecff;
  box-sizing: border-box;
  margin: 0;
}

.czje > span:first-child {
  color: #555;
  flex-shrink: 0;
}

.price {
  text-align: right;
  color: #333;
  word-break: break-all;
}

.price.accent {
  color: #3464ff;
  font-weight: 600;
}

.price.network {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.price.network img {
  width: 22px;
  height: 22px;
}

.mono-sm {
  font-family: Consolas, Menlo, monospace;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  max-width: 68%;
}

.mini-copy,
.qrcode_copy {
  border: 1px solid #e1e6f0;
  background: #f7f9ff;
  color: #3464ff;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  flex-shrink: 0;
}

.sxf {
  padding: 14px 12px;
  margin: 18px 0 8px;
  background: #fff5e2;
  color: #ffac00;
  font-size: 13px;
  border-radius: 6px;
  line-height: 1.5;
}

.form-box {
  margin-top: 18px;
}

.paysubmit {
  width: 90%;
  display: block;
  margin: 18px auto 0;
  border: none;
  color: #fff;
  font-size: 16px;
  line-height: 50px;
  height: 50px;
  border-radius: 25px;
  background: #3464ff;
  box-shadow: 0 4px 7px rgba(0, 54, 249, 0.2);
  cursor: pointer;
}

.dzsj {
  margin-top: 18px;
  text-align: center;
  color: #8187a1;
  font-size: 13px;
}

.qrcode_usdt {
  margin-top: 20px;
  border: 1px solid #e1e6f0;
  border-radius: 8px;
  overflow: hidden;
}

.qrcode_title {
  margin: 0;
  padding: 0 15px;
  line-height: 44px;
  font-size: 16px;
  background: #f7f9ff;
  border-bottom: 1px solid #e1e6f0;
  color: #000;
}

.qrcode_form {
  padding: 15px 15px 8px;
}

.form_list {
  margin-bottom: 8px;
}

.qrcode_label {
  display: block;
  color: #8187a1;
  font-size: 13px;
  padding: 0 0 10px;
  line-height: 1.4;
}

.qrcode_right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e1e6f0;
  border-radius: 4px;
  min-height: 38px;
}

.qrcode_price {
  padding: 0 12px;
  box-sizing: border-box;
  width: 100%;
  line-height: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}

.qrcode_price1 {
  padding: 9px 11px;
  white-space: normal;
  word-break: break-all;
  line-height: 1.5;
}

.fwb {
  font-weight: 700;
  margin-right: 4px;
}

.form_tips {
  color: #999;
  font-size: 12px;
  line-height: 1.5;
  margin: 0 0 10px;
}

.form_tips.warn {
  color: #ffac00;
  background: #fff8ea;
  padding: 8px 10px;
  border-radius: 4px;
}

.qrcode_center {
  display: flex;
  justify-content: center;
  padding: 8px 0 4px;
}

.qrcode_code {
  width: 200px;
  height: 200px;
}

.qrcode-el,
.qrcode-el >>> img,
.qrcode-el >>> canvas {
  width: 200px !important;
  height: 200px !important;
}

.qrcode_djs {
  text-align: center;
  color: #3464ff;
  font-size: 14px;
  padding: 10px 0 16px;
}

.state-wrap {
  width: min(420px, 90%);
  margin: 80px auto;
  background: #fff;
  border-radius: 16px;
  padding: 40px 24px;
  text-align: center;
  color: #333;
}

.state-wrap.card {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
}

.loader {
  width: 36px;
  height: 36px;
  margin: 0 auto 12px;
  border: 3px solid #dbe4ff;
  border-top-color: #3464ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.result-icon {
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 0 auto 12px;
  border-radius: 50%;
  color: #fff;
  font-size: 28px;
}

.result-icon.ok {
  background: #22c55e;
}

.result-icon.timeout {
  background: #f59e0b;
}

.error-text {
  color: #e11d48;
}

@media screen and (max-width: 800px) {
  .box {
    width: 94%;
    margin-top: 8px;
  }

  .box-top {
    font-size: 26px;
  }

  .usdt-logo {
    width: 56px;
    height: 56px;
  }

  .box-main {
    padding: 4px 16px 28px;
  }

  .czje {
    font-size: 14px;
    line-height: 48px;
    min-height: 48px;
  }

  .mono-sm {
    max-width: 62%;
    font-size: 12px;
  }
}
</style>
